import Vue from 'vue'

import _ from 'lodash'

import { mapGetters } from 'vuex'

const Modal = Vue.component(
  'Modal',
  require('_/components/UserInterface/Modal/Modal.vue').default
)

const Select2 = Vue.component(
  'Select2',
  require('_/components/FieldTypes/Select2/Select2.vue').default
)

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    asset: {
      default: {},
      type: Object,
    },
  },

  /**
   * Set the data property
   *
   * @return  {object}
   */
  data() {
    return {
      /**
       * Stores image sizes select options
       *
       * @type  {Array}
       */
      imageSizes: [],

      /**
       * Stores chosen image size  option
       *
       * @type  {String}
       */
      choosenSize: null,

      /**
       * Stores image template title
       *
       * @type  {String}
       */
      title: '',
    }
  },

  /**
   * Set the components
   *
   * @return  {object}
   */
  components: {
    Modal,
    Select2,
  },

  /**
   * Set the computed properties
   *
   * @type  {object}
   */
  computed: {
    ...mapGetters({
      admin: 'admin/admin',
      ui: 'ui/ui',
    }),
  },

  /**
   * Set the methods
   *
   * @type  {object}
   */
  methods: {
    /**
     * Emmits closed modal event to parent component
     *
     * @return  {void}
     */
    closeInsertImageModal() {
      this.$emit('closedInsertImageModal')
    },

    /**
     * Emmits closed modal with completed insertion event
     *
     * @return  {void}
     */
    finishEditing() {
      let { choosenSize, title } = this
      this.$emit('finsihedInsertImageModal', { choosenSize, title })
    },

    /**
     * On change image size selection event handler
     *
     * @param {Event} event
     * @return  {void}
     */
    onChange(event) {
      this.choosenSize = event.value
    },

    /**
     * Set form initial values and options.
     *
     * @return  {void}
     */
    initializeForm() {
      this.imageSizes = this.asset ? this.getImageSizeOptions(this.asset) : []
      this.choosenSize =
        this.imageSizes.length > 0 ? this.imageSizes[0].value : null
      this.title = this.asset ? this.getImageTitle(this.asset) : ''
    },

    /**
     * Extract image sizes options from provided asset
     *
     * @param {Object} asset
     * @return  {Array}
     */
    getImageSizeOptions(asset) {
      let defaultLocale = this.ui.defaultLocale.languageCode
      let options = []
      if (_.get(asset, 'fields.resized_images')) {
        const sizes = Object.keys(asset.fields.resized_images)
        options = sizes.map(size => {
          let option = {}
          ;(option.id = size),
            (option.value = size),
            (option.text = asset.fields.resized_images[size].fields.image_size
              .fields.name[defaultLocale]
              ? asset.fields.resized_images[size].fields.image_size.fields.name[
                  defaultLocale
                ]
              : '')
          return option
        })
      }
      return options
    },

    /**
     * Extract image title from provided asset
     *
     * @param {Object} asset
     * @return  {String}
     */
    getImageTitle(asset) {
      let defaultLocale = this.ui.defaultLocale.languageCode
      return asset.fields.title[defaultLocale]
        ? asset.fields.title[defaultLocale]
        : asset.fields.storage_file_name
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(() => {
      this.initializeForm()
    })
  },

  watch: {
    refreshFields(newEntry, oldEntry) {
      if (newEntry !== oldEntry) {
      }
    },
    asset(newEntry, oldEntry) {
      if (newEntry !== oldEntry) {
        this.initializeForm()
      }
    },
  },
}
